import { ERROR_OCCURRED } from './types';

export const createError = (
  error = { code: 'default', message: '', timestamp: new Date() },
) => {
  if (typeof error === 'string') {
    return {
      type: ERROR_OCCURRED,
      payload: {
        error,
      },
    };
  }

  return {
    type: ERROR_OCCURRED,
    payload: {
      error: {
        code: error.code || error.error_code,
        message: error.message,
        timestamp: error.timestamp,
      },
    },
  };
};
